import { rebuildPosicions } from "../../../utils/loadPositions";

const normalizePestanya = (pestanya) => String(pestanya || '').toLowerCase();

const getCaixaId = (log) => log?.split(',')?.[0];

const isFustesLog = (log) => getCaixaId(log) === 'FUSTES';

const getPosicionsLogFromData = (data) => String(data || '').split('\n').slice(1);

const caixaIsInPestanya = (caixa, pestanya) => {
    if (!caixa || typeof caixa !== 'object') return false;

    const normalizedPestanya = normalizePestanya(pestanya);

    if (normalizedPestanya === 'tronc') {
        return 'pilar' in caixa || normalizePestanya(caixa?.pestanya) === 'tronc';
    }

    return normalizePestanya(caixa?.pestanya) === normalizedPestanya;
};

const getIdsInPestanya = (json = {}, pestanya) => (
    Object.entries(json)
        .filter(([_, caixa]) => caixaIsInPestanya(caixa, pestanya))
        .map(([caixaId]) => caixaId)
);

const removeSourcePartPrefix = (log) => (
    log.indexOf('_') > -1 ? log.split('_')[1] : log
);

const withTargetPartPrefix = (log, chosenPartId) => (
    chosenPartId ? `${chosenPartId}_${log}` : log
);

const getPlantillaFromPestanya = (chosenPartId, selectedBundle, pestanya, bundlesInfo = []) => {
    const matchedBundle = bundlesInfo
        ?.find(bundle => bundle.id === selectedBundle);

    if (!matchedBundle) return undefined;

    if (matchedBundle.simultani) {
        const idFromPartId = matchedBundle?.bundles?.[chosenPartId]?.id || null;
        const matchedBundles = Object.values(matchedBundle.bundles || {})
            .map(bundle => bundlesInfo.find(b => b.id === bundle.id))
            .filter(bundle => bundle !== undefined);

        if (matchedBundles?.length === 0) return undefined;

        const chosenBundle = matchedBundles
            .find(bundle => bundle.id === idFromPartId);

        const matchedPart = Object.entries(chosenBundle?.parts || {})
            .find(([part]) => normalizePestanya(part) === normalizePestanya(pestanya));

        return matchedPart?.[1];
    }

    const matchedPart = Object.entries(matchedBundle?.parts || {})
        .find(([part]) => normalizePestanya(part) === normalizePestanya(pestanya));

    return matchedPart?.[1];
};

const buildAvailableImportLog = ({
    posicionsLogsCastell,
    json,
    pestanya,
    chosenPartId
}) => {
    const idsInPestanya = getIdsInPestanya(json, pestanya);
    const logs = getPosicionsLogFromData(posicionsLogsCastell);

    return [
        ...logs
            .filter(log => !isFustesLog(log))
            .map(removeSourcePartPrefix)
            .map(log => withTargetPartPrefix(log, chosenPartId))
            .filter(log => idsInPestanya.includes(getCaixaId(log))),
        ...(normalizePestanya(pestanya) === 'tronc'
            ? logs.filter(isFustesLog)
            : [])
    ];
};

const buildAvailableImportPreviewPosicions = ({
    posicionsLogs,
    json,
    pestanya,
    chosenPartId
}) => (
    posicionsLogs.map(castells => castells.map(posicionsLogsCastell => rebuildPosicions({
        posicionsLog: buildAvailableImportLog({
            posicionsLogsCastell,
            json,
            pestanya,
            chosenPartId
        })
    })))
);

const buildImportedPestanyaLog = ({
    fullPosicionsLog,
    json,
    pestanya,
    chosenPartId,
    chosenBundleIsSimultani
}) => {
    const idsInPestanya = getIdsInPestanya(json, pestanya);

    return fullPosicionsLog
        .map(log => {
            if (isFustesLog(log)) {
                return normalizePestanya(pestanya) === 'tronc' ? log : null;
            }

            return !chosenBundleIsSimultani && chosenPartId
                ? withTargetPartPrefix(log, chosenPartId)
                : log;
        })
        .filter(log => log !== null)
        .filter(log => isFustesLog(log) || idsInPestanya.includes(getCaixaId(log)));
};

export {
    buildAvailableImportPreviewPosicions,
    buildImportedPestanyaLog,
    caixaIsInPestanya,
    getCaixaId,
    getIdsInPestanya,
    getPlantillaFromPestanya,
    getPosicionsLogFromData,
    isFustesLog,
    normalizePestanya
};
